<!-- Full-screen confetti overlay -->
<div class="confetti-overlay" *ngIf="showConfetti">
  <div class="confetti-piece" *ngFor="let piece of confettiPieces" [style.left.%]="piece.left"
    [style.animation-delay.s]="piece.animationDelay" [style.background-color]="piece.backgroundColor"
    [style.width.px]="piece.size" [style.height.px]="piece.size"></div>
</div>

<div class="checklist-container" *ngIf="isVisible" [class.completed]="isCompleted">
  <!-- Close Button - Outside the card -->
  <button mat-icon-button class="close-button" (click)="closeChecklist()" [matTooltip]="t.ChecklistCloseAndSkip">
    <mat-icon>close</mat-icon>
  </button>

  <!-- Simplified View - Just the Current Step -->
  <div class="checklist-card">
    <!-- Current Step Display -->
    <div class="current-step-container" *ngIf="!isCompleted">
      <div *ngFor="let step of steps; let i = index" class="current-step" [class.visible]="isNextStep(step)"
        [class.clickable]="!step.completed && step.action" (click)="onStepClick(step)"
        [attr.role]="step.action && !step.completed ? 'button' : null"
        [attr.tabindex]="step.action && !step.completed ? 0 : null" (keydown.enter)="onStepClick(step)"
        (keydown.space)="onStepClick(step); $event.preventDefault()">
        <div class="step-number">{{ i + 1 }}/{{ totalCount }}</div>
        <div class="step-content">
          <div class="step-label">{{ step.label }}</div>
          <div class="step-hint" *ngIf="isNextStep(step)">{{ t.ChecklistTapToOpen }}</div>
        </div>
        <mat-icon class="step-action-icon">arrow_forward</mat-icon>
      </div>
    </div>

    <!-- Completion Message -->
    <div class="completion-message" *ngIf="isCompleted">
      <mat-icon class="completion-icon">check_circle</mat-icon>
      <p class="completion-text">{{ t.ChecklistAwesomeAllSet }}</p>
    </div>
  </div>
</div>